export default __webpack_public_path__ + "static/media/DocEye.b04ba1c3.svg";